import request from '@/util/request';
import qs from 'qs';

// 分页
export const getPageList = (params, options) =>
  request.get('/api/shunt/meter/fee/record/page', Object.assign({}, options, { params }));

// 详情
export const getDetail = (params, options) =>
  request.get('/api/shunt/meter/fee/record/detail', Object.assign({}, options, { params }));

// 新增
export const add = (params, options) =>
  request.post('/api/shunt/meter/fee/record/save', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const update = (params, options) =>
  request.post('/api/shunt/meter/fee/record/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const remove = (params, options) =>
  request.post('/api/shunt/meter/fee/record/remove', qs.stringify(params), options);

// 计算总费用
export const getSumAmount = (params, options) =>
  request.get('/api/shunt/meter/fee/record/calc-fee', Object.assign({}, options, { params }));

